import { render } from "./PsModal.vue?vue&type=template&id=a85de9ac&scoped=true&ts=true"
import script from "./PsModal.vue?vue&type=script&lang=ts"
export * from "./PsModal.vue?vue&type=script&lang=ts"

import "./PsModal.vue?vue&type=style&index=0&id=a85de9ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a85de9ac"]])

export default __exports__